import { t } from '@hefe/i18n';
import { TaskableType } from '@hefe/models';
import {
  BasketballTeamsSlice,
  BasketballUsersSlice,
  ClubSlice,
  TasksActions,
} from '@hefe/store';
import { Col, Row, Spin, Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import TasksAssignmentsComponent from '../../components/tasks-assignments/tasks-assignments.component';
import TasksListComponent from '../../components/tasks-list/tasks-list.component';

export default function ClubTasksPage() {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);

  const tasks = useSelector(ClubSlice.clubTasksSelector);

  useEffect(() => {
    fetchTasks();
    fetchUsersAndTeams();
  }, []);

  const tasksMenuItems = useMemo(() => {
    return tasks.map((task) => ({
      label: task.name,
      key: 'club_' + task.id,
    }));
  }, [tasks]);

  const fetchTasks = () => {
    setLoading(true);
    dispatch(TasksActions.fetchClubTasks())
      .unwrap()
      .finally(() => setLoading(false));
  };

  const fetchUsersAndTeams = () => {
    dispatch(
      BasketballTeamsSlice.fetchBasketballTeamsSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    );
    dispatch(
      BasketballUsersSlice.fetchBasketballUsersSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };

  if (loading) {
    return (
      <Row align="middle" justify="center">
        <Col>
          <Spin size="large" />
        </Col>
      </Row>
    );
  }

  return (
    <Tabs
      items={[
        {
          key: 'assignments',
          label: 'Zuweisungen',
          children: (
            <TasksAssignmentsComponent
              type={TaskableType.CLUB}
              items={tasksMenuItems}
            />
          ),
        },
        {
          key: 'tasks',
          label: t('tasks.plural'),
          children: (
            <TasksListComponent tasks={tasks} type={TaskableType.CLUB} />
          ),
        },
      ]}
    />
  );
}
